new Swiper('.cases__swiper', {
  speed: 400,
  slidesPerView: 1,
  spaceBetween: 20,
  // loop: true,

  breakpoints: {
    320: { loop: true },
    1280: { loop: false },
  },

  navigation: {
    nextEl: '.cases__swiper-next',
    prevEl: '.cases__swiper-prev',
  },
});
